module.exports = __webpack_public_path__ + "img/recipientfees.7844850c.png";